import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const StepOverview = lazy(() => import('./step-overview'));
const StepCreate = lazy(() => import('./step-create/step-create.component'));
const StepDetail = lazy(() => import('./step-detail/step-detail.component'));
const StepUpdate = lazy(() => import('./step-update/step-update.component'));

export function StepRoutes() {
    return (
        <Route path='steps'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <StepOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <StepCreate />
                    </AsyncComponent>
                }
            />

            <Route path=':stepId'>
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <StepUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <StepDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
